import React, { Fragment, useEffect } from 'react';
import cx from 'classnames';
import moment from 'moment';
import ReactTooltip from 'react-tooltip';
import { Icon } from '@ontruck/orc';

import { ReactComponent as PickupIcon } from 'assets/icons/pickup.svg';
import { ReactComponent as DropoffIcon } from 'assets/icons/dropoff.svg';

import { PalletsCell, WeightCell, HeightCell } from 'utils/format';
import { cellWidth } from 'modules/job-review/utils';
import { IS_TENANT } from 'tenant/config';

const stopTypeIcons = {
  PICKUP: <PickupIcon />,
  DROPOFF: <DropoffIcon />,
};

const t = {
  actions: 'Actions',
};

const DriverDayStop = ({
  className,
  stop,
  stopKey,
  isFilled,
  isFirst,
  isLast,
  startsEmpty,
  endsEmpty,
  showActions,
  actionsDisabled,
  driverDayId,
  shipperOrderIds,
}) => {
  useEffect(() => {
    ReactTooltip.rebuild();
  });

  return (
    <div className={className}>
      <div className="container">
        <div className="cell cell__nogrow cell__skin" {...cellWidth('24px')} />
        <div className="cell cell__right cell__padding" {...cellWidth('260px')}>
          <div>
            <strong>{stop?.address?.company_name}</strong>
          </div>
          <div>{stop?.address?.address_line}</div>
          <div>
            {stop?.address?.label} - {stop?.address?.city}
          </div>
        </div>
        <div className="cell">
          <div
            className={cx('stop-timings', {
              'stop-timings__filled': isFilled,
              'stop-timings__first_stop': isFirst,
              'stop-timings__last_stop': isLast,
              'stop-timings__starts_empty': startsEmpty,
              'stop-timings__ends_empty': endsEmpty,
            })}
            {...cellWidth('125px')}
          >
            <div className="stop-timings__number">{stopKey}</div>
            <div className="stop-timings__times">
              {!!stop?.time_from && !!stop?.time_to && (
                <>
                  {moment(stop?.time_from).format('HH:mm')} -{' '}
                  {moment(stop?.time_to).format('HH:mm')}
                </>
              )}
            </div>
          </div>
        </div>
        <div className="cell cell__padding" {...cellWidth('40px')}>
          {!!stopTypeIcons[stop?.stop_type] && stopTypeIcons[stop?.stop_type]}
        </div>

        <div className="cell cell__padding">
          {stop?.loads?.map((load, key) => (
            <div key={key} className="load">
              <div {...cellWidth('70px')} className="load__cell load__right">
                <span>
                  {IS_TENANT && <>{load.container_iso_code ? 'Tara: ' : 'Carga: '}</>}
                  <WeightCell weight={load.total_weight} />
                </span>
              </div>
              <div {...cellWidth(IS_TENANT ? '34px' : '54px')} className="load__cell load__right">
                <span>
                  <HeightCell height={load.item_height} />
                </span>
              </div>
              <div {...cellWidth(IS_TENANT ? '68px' : '48px')} className="load__cell load__right">
                <strong>
                  <PalletsCell
                    realPallets={load.real_pallets}
                    typePallets={load.pallet_type}
                    withEquivalents={false}
                    load={load}
                    stops={stop?.loads}
                  />
                </strong>
              </div>
              <div {...cellWidth('105px')} className="load__cell load__right">
                {load.pallet_type === 'CUSTOM_PALLET' && !IS_TENANT && (
                  <>
                    ({load.item_width}
                    cm &times; {load.item_length}
                    cm)
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
        <div className="cell cell__padding extras">
          <div className="extra">
            {stop?.shipper_order_extras.indexOf('LIFTGATE') >= 0 ? (
              <Icon glyph="extras-liftgate" size="2rem" color="grey500" />
            ) : null}
          </div>
          <div className="extra">
            {stop?.shipper_order_extras.indexOf('SIDE_LOAD') >= 0 ? (
              <Icon glyph="extras-sideload" size="2rem" color="grey500" />
            ) : null}
          </div>
          <div className="extra">
            {stop?.shipper_order_extras.indexOf('TOP_LOAD') >= 0 ? (
              <Icon glyph="extras-retractableroof" size="2rem" color="grey500" />
            ) : null}
          </div>
        </div>
        <div className="cell cell__padding cell__grow cell__dark">
          {(stop?.comments || [])
            .join('')
            .split('\n')
            .map((item, key) => {
              return (
                <Fragment key={key}>
                  {item}
                  <br />
                </Fragment>
              );
            })}
        </div>
        {showActions && (
          <div className="cell cell__padding cell__dark">
            <button
              disabled={actionsDisabled}
              data-tip={JSON.stringify({
                driverDayId: driverDayId,
                journeyId: stop?.journey_id,
                carrierPhone: stop?.carrier_phone,
                shipperPhone: stop?.shipper_phone,
                shipperOrderId: stop?.shipper_order_id,
                shipperOrderIds: shipperOrderIds,
              })}
              data-for="actions-tooltip"
              data-event="click"
              className="actions-button"
            >
              {t.actions}
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

const DriverDayStopSeparator = ({ className }) => {
  return <div className={`${className} separator`} />;
};

export default DriverDayStop;
export { DriverDayStopSeparator };
